import { Component, ElementRef, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
})
export class ConfirmDialogComponent implements OnInit {

  public confirmDialogState: boolean = false;
  public args: any = null;

  constructor(public dialogService: ConfirmDialogService, public componentElement: ElementRef) { }

  ngOnInit(): void {

    // reposition page loader
    const confirmDialog = this.componentElement.nativeElement.querySelector("div");
    document.body.appendChild(confirmDialog);

    //
    // listen for page loader change
    this.dialogService.confirm.subscribe((args: any) => {
      this.args = args;
    });
  }

  confirm(evt: any) {
    this.args?.okay(this.args?.data);
    this.dialogService.hide();
  }

  close(evt: any) {
    this.dialogService.hide();
  }
}
